export const settingsTranslations = {
  ru: {
    'settings.title': 'Настройки организации',
    'settings.subtitle': 'Лимиты и возможности выбранной организации',
    'settings.subtitleNamed': 'Лимиты и возможности · {name}',
    'settings.noOrganizationSelected': 'Выберите организацию в верхней панели.',
    'settings.tabs.quota': 'Лимиты',
    'settings.tabs.users': 'Пользователи',
    'settings.tabs.outlets': 'Outlets',
    'settings.tabs.telegram': 'Telegram',
    'settings.telegram.title': 'Привязка Telegram',
    'settings.telegram.subtitle': 'Одноразовый персональный код (около 10 минут). Покажите ссылку или код сотруднику с телефоном.',
    'settings.telegram.needOutlet': 'Выберите Outlet в верхней панели, чтобы привязать Telegram.',
    'settings.telegram.disabled': 'Telegram-инбокс выключен на сервере (Telegram__Enabled).',
    'settings.telegram.linked': 'Привязан Telegram user #{id}',
    'settings.telegram.linkedAt': 'Связка создана: {date}',
    'settings.telegram.generate': 'Сгенерировать код',
    'settings.telegram.regenerate': 'Новый код',
    'settings.telegram.unlink': 'Отвязать',
    'settings.telegram.code': 'Код',
    'settings.telegram.deepLink': 'Ссылка в бота',
    'settings.telegram.expires': 'Действует до {date}',
    'settings.telegram.copyCode': 'Копировать код',
    'settings.telegram.openBot': 'Открыть бота',
    'settings.telegram.loading': 'Загружаем статус Telegram…',
    'settings.telegram.loadError': 'Не удалось загрузить статус Telegram.',
    'settings.telegram.generateError': 'Не удалось создать код.',
    'settings.telegram.unlinkError': 'Не удалось отвязать Telegram.',
    'settings.telegram.unlinkConfirm': 'Отвязать этот Telegram от вашей учётки?',
    'settings.organization': 'Организация',
    'settings.organizationLabel': 'Организация: {name}',
    'settings.quota.title': 'Квота организации',
    'settings.quota.limitsTitle': 'Лимиты',
    'settings.quota.capabilitiesTitle': 'Возможности',
    'settings.quota.loading': 'Загружаем лимиты организации…',
    'settings.quota.maxChains': 'Максимум сетей',
    'settings.quota.maxLocations': 'Максимум точек (outlets)',
    'settings.quota.maxRmsConnections': 'Максимум подключений Syrve',
    'settings.quota.maxUsers': 'Максимум пользователей',
    'settings.quota.allowBankUpload': 'Загрузка банковских выписок',
    'settings.quota.allowBankUploadHint': 'Разрешить пользователям этой организации загружать выписки',
    'settings.quota.allowAutoSync': 'Синхронизация документов Syrve',
    'settings.quota.allowAutoSyncHint': 'Автоматически подтягивать накладные и связанные документы из Syrve',
    'settings.quota.save': 'Сохранить',
    'settings.quota.noPermission': 'Изменение лимитов доступно только администраторам платформы.',
    'settings.quota.saved': 'Настройки организации сохранены.',
    'settings.quota.loadError': 'Не удалось загрузить лимиты организации.',
    'settings.quota.saveError': 'Не удалось сохранить настройки.',
    'settings.platform.pageTitle': 'Настройки платформы',
    'settings.platform.pageSubtitle': 'Глобальные переключатели и параметры сопоставления для всей платформы',
    'settings.platform.featuresTitle': 'Функции платформы',
    'settings.platform.matchingTitle': 'Сопоставление платежей',
    'settings.platform.bankUpload': 'Загрузка банковских выписок',
    'settings.platform.bankUploadHint': 'Глобально разрешить или запретить загрузку выписок',
    'settings.platform.docSync': 'Синхронизация документов Syrve',
    'settings.platform.docSyncHint': 'Глобально включить или выключить синхронизацию документов',
    'settings.platform.matchingDateTolerance': 'Допуск по дате (дней)',
    'settings.platform.matchingDateToleranceHint': 'На сколько дней может отличаться дата платежа при автосопоставлении',
    'settings.platform.matchingAmountTolerance': 'Допуск по сумме',
    'settings.platform.matchingAmountToleranceHint': 'Максимальное отклонение суммы при точном сопоставлении',
    'settings.platform.save': 'Сохранить',
    'settings.platform.saved': 'Настройки платформы сохранены.',
    'settings.platform.saveError': 'Не удалось сохранить настройки платформы.',
    'settings.platform.loadError': 'Не удалось загрузить настройки платформы.',
    'settings.platform.loading': 'Загружаем настройки платформы…',
    'settings.platform.noPermission': 'Нет доступа к настройкам платформы.',
    'settings.platform.viewOnly': 'Только просмотр. Изменение доступно администраторам платформы.',
    'settings.users.title': 'Пользователи и роли',
    'settings.users.hint': 'Scoped RBAC: назначения ролей в рамках организации и локаций. Legacy flat roles остаются для совместимости на backend.',
    'settings.users.listTitle': 'Пользователи организации',
    'settings.users.listSubtitle': 'Список пользователей и их ролей в активной организации',
    'settings.users.inviteTitle': 'Пригласить пользователя',
    'settings.users.inviteHint': 'Отправьте ссылку новому сотруднику — он задаст пароль и получит роль в этой организации.',
    'settings.users.inviteEmail': 'Email',
    'settings.users.inviteSubmit': 'Создать приглашение',
    'settings.users.inviteSuccess': 'Приглашение создано. Скопируйте ссылку и передайте пользователю.',
    'settings.users.inviteLinkLabel': 'Ссылка для принятия инвайта',
    'settings.users.inviteError': 'Не удалось создать приглашение.',
    'settings.users.inviteRoleRequired': 'Выберите роль.',
    'settings.users.inviteEmailRequired': 'Укажите email.',
    'settings.users.manageHint': 'Откройте карточку пользователя, чтобы изменить роли и назначения.',
    'settings.users.detailTitle': 'Пользователь: {name}',
    'settings.users.detail.profileTitle': 'Профиль пользователя',
    'settings.users.detail.assignmentsTitle': 'Назначения ролей',
    'settings.users.detail.roleSummary': 'Текущие роли: {roles}',
    'settings.users.detail.notFound': 'Пользователь не найден в активной организации.',
    'settings.users.noOrganization': 'Нет активной организации для управления пользователями.',
    'settings.users.backToList': 'Назад к пользователям',
    'settings.users.loading': 'Загружаем пользователей организации…',
    'settings.users.loadError': 'Не удалось загрузить пользователей и роли.',
    'settings.users.empty.title': 'Нет назначений',
    'settings.users.empty.description': 'Пока нет пользователей с ролями в этой организации.',
    'settings.users.column.user': 'Пользователь',
    'settings.users.column.role': 'Роль',
    'settings.users.column.roles': 'Роли',
    'settings.users.column.scope': 'Scope',
    'settings.users.column.assignments': 'Назначения',
    'settings.users.column.actions': 'Действия',
    'settings.users.assignmentsCount': '{count} назнач.',
    'settings.users.action.open': 'Открыть',
    'settings.users.action.manage': 'Управление',
    'settings.users.scope.location': 'Локация: {name}',
    'settings.users.scope.organization': 'Организация',
    'settings.users.viewOnly': 'Только просмотр',
    'settings.users.remove': 'Удалить',
    'settings.users.userId': 'User ID',
    'settings.users.userIdPlaceholder': 'UUID пользователя',
    'settings.users.role': 'Роль',
    'settings.users.selectRole': 'Выберите роль',
    'settings.users.rolesLoadError': 'Не удалось загрузить список ролей. Обновите страницу.',
    'settings.users.noRolesAvailable': 'Нет доступных ролей для приглашения. Проверьте права или обратитесь к администратору.',
    'settings.users.locationsLoadError': 'Не удалось загрузить список локаций. Обновите страницу.',
    'settings.users.noOutletsInOrganization': 'В организации нет outlets — будет назначена роль на всю организацию.',
    'settings.users.locationOptional': 'Локация (опционально)',
    'settings.users.wholeOrganization': 'Вся организация',
    'settings.users.assignRole': 'Назначить роль',
    'settings.users.roleAssigned': 'Роль назначена.',
    'settings.users.roleRemoved': 'Назначение роли удалено.',
    'settings.users.assignError': 'Не удалось назначить роль.',
    'settings.users.removeError': 'Не удалось удалить назначение.',
    'settings.bankAdapters.title': 'Банковские адаптеры',
    'settings.bankAdapters.subtitle': 'Технический каталог поддерживаемых форматов выписок (только просмотр)',
    'settings.bankAccounts.title': 'Счета банка',
    'settings.bankAccounts.subtitle': 'Сопоставление банка с финансовым Account Syrve',
    'settings.bankAccounts.loading': 'Загружаем счета банка…',
    'settings.bankAccounts.loadError': 'Не удалось загрузить счета банка.',
    'settings.bankAccounts.saveError': 'Не удалось сохранить сопоставление счёта банка.',
    'settings.bankAccounts.validationRequired': 'Выберите Account Syrve.',
    'settings.bankAccounts.created': 'Сопоставление счёта банка создано.',
    'settings.bankAccounts.saved': 'Сопоставление счёта банка сохранено.',
    'settings.bankAccounts.col.logo': 'Банк',
    'settings.bankAccounts.col.bank': 'Наименование',
    'settings.bankAccounts.col.account': 'Account Syrve',
    'settings.bankAccounts.pickAccount': 'Account Syrve',
    'settings.bankAccounts.save': 'Сохранить',
    'settings.bankAccounts.viewOnly': 'Изменение сопоставления доступно бухгалтеру.',
    'settings.docs.title': 'Документация',
    'settings.docs.subtitle': 'Портал документации MyHoreca Pay',
    'settings.docs.linkPrefix': 'Полная документация доступна на',
    'settings.outlets.pageTitle': 'Outlets организации',
    'settings.outlets.pageSubtitle': 'Точки продаж (Outlet) для операционного контекста и RMS-подключений Syrve',
    'settings.outlets.pageSubtitleNamed': 'Outlets · {name}',
    'settings.outlets.listTitle': 'Список Outlets',
    'settings.outlets.listSubtitle': 'Активные точки в выбранной организации',
    'settings.outlets.createTitle': 'Новый Outlet',
    'settings.outlets.createSubtitle': 'Для RMS Syrve нужен хотя бы один Outlet в Pay',
    'settings.outlets.name': 'Название',
    'settings.outlets.namePlaceholder': 'Например, Основной ресторан',
    'settings.outlets.code': 'Код',
    'settings.outlets.codePlaceholder': 'main',
    'settings.outlets.codeHint': 'Короткий уникальный код внутри организации (латиница, цифры, дефис).',
    'settings.outlets.create': 'Создать Outlet',
    'settings.outlets.createAndContinue': 'Создать Outlet и выбрать',
    'settings.outlets.created': 'Outlet создан.',
    'settings.outlets.createError': 'Не удалось создать Outlet.',
    'settings.outlets.validationRequired': 'Укажите название и код Outlet.',
    'settings.outlets.loading': 'Загружаем Outlets…',
    'settings.outlets.loadError': 'Не удалось загрузить список Outlets.',
    'settings.outlets.empty': 'В организации пока нет Outlets.',
    'settings.outlets.column.name': 'Название',
    'settings.outlets.column.code': 'Код',
    'settings.outlets.viewOnly': 'Создание Outlets доступно администратору организации.',
    'settings.outlets.compactHint': 'RMS-подключение привязано к Outlet. Создайте Outlet прямо здесь — поля можно заполнить из названия подключения и адреса сервера.',
  },
  en: {
    'settings.title': 'Organization settings',
    'settings.subtitle': 'Limits and capabilities for the selected organization',
    'settings.subtitleNamed': 'Limits and capabilities · {name}',
    'settings.noOrganizationSelected': 'Select an organization in the header.',
    'settings.tabs.quota': 'Limits',
    'settings.tabs.users': 'Users',
    'settings.tabs.outlets': 'Outlets',
    'settings.tabs.telegram': 'Telegram',
    'settings.telegram.title': 'Telegram link',
    'settings.telegram.subtitle': 'One-time personal code (~10 minutes). Share the deep link or the code if phone and PC are separate.',
    'settings.telegram.needOutlet': 'Select an Outlet in the header to link Telegram.',
    'settings.telegram.disabled': 'Telegram inbox is disabled on the server (Telegram__Enabled).',
    'settings.telegram.linked': 'Linked Telegram user #{id}',
    'settings.telegram.linkedAt': 'Linked at: {date}',
    'settings.telegram.generate': 'Generate code',
    'settings.telegram.regenerate': 'New code',
    'settings.telegram.unlink': 'Unlink',
    'settings.telegram.code': 'Code',
    'settings.telegram.deepLink': 'Bot link',
    'settings.telegram.expires': 'Valid until {date}',
    'settings.telegram.copyCode': 'Copy code',
    'settings.telegram.openBot': 'Open bot',
    'settings.telegram.loading': 'Loading Telegram status…',
    'settings.telegram.loadError': 'Failed to load Telegram status.',
    'settings.telegram.generateError': 'Failed to create code.',
    'settings.telegram.unlinkError': 'Failed to unlink Telegram.',
    'settings.telegram.unlinkConfirm': 'Unlink this Telegram account from your Pay user?',
    'settings.organization': 'Organization',
    'settings.organizationLabel': 'Organization: {name}',
    'settings.quota.title': 'Organization quota',
    'settings.quota.limitsTitle': 'Limits',
    'settings.quota.capabilitiesTitle': 'Capabilities',
    'settings.quota.loading': 'Loading organization limits…',
    'settings.quota.maxChains': 'Max chains',
    'settings.quota.maxLocations': 'Max outlets',
    'settings.quota.maxRmsConnections': 'Max Syrve connections',
    'settings.quota.maxUsers': 'Max users',
    'settings.quota.allowBankUpload': 'Bank statement upload',
    'settings.quota.allowBankUploadHint': 'Allow users in this organization to upload statements',
    'settings.quota.allowAutoSync': 'Syrve document sync',
    'settings.quota.allowAutoSyncHint': 'Automatically sync invoices and related Syrve documents',
    'settings.quota.save': 'Save',
    'settings.quota.noPermission': 'Only platform administrators can change organization limits.',
    'settings.quota.saved': 'Organization settings saved.',
    'settings.quota.loadError': 'Failed to load organization limits.',
    'settings.quota.saveError': 'Failed to save settings.',
    'settings.platform.pageTitle': 'Platform settings',
    'settings.platform.pageSubtitle': 'Global switches and matching parameters for the whole platform',
    'settings.platform.featuresTitle': 'Platform features',
    'settings.platform.matchingTitle': 'Payment matching',
    'settings.platform.bankUpload': 'Bank statement upload',
    'settings.platform.bankUploadHint': 'Globally allow or deny statement upload',
    'settings.platform.docSync': 'Syrve document sync',
    'settings.platform.docSyncHint': 'Globally enable or disable document sync',
    'settings.platform.matchingDateTolerance': 'Date tolerance (days)',
    'settings.platform.matchingDateToleranceHint': 'How many days payment dates may differ during auto-matching',
    'settings.platform.matchingAmountTolerance': 'Amount tolerance',
    'settings.platform.matchingAmountToleranceHint': 'Maximum amount deviation for exact matching',
    'settings.platform.save': 'Save',
    'settings.platform.saved': 'Platform settings saved.',
    'settings.platform.saveError': 'Failed to save platform settings.',
    'settings.platform.loadError': 'Failed to load platform settings.',
    'settings.platform.loading': 'Loading platform settings…',
    'settings.platform.noPermission': 'No access to platform settings.',
    'settings.platform.viewOnly': 'View only. Changes require platform administrator rights.',
    'settings.users.title': 'Users and roles',
    'settings.users.hint': 'Scoped RBAC: role assignments within organization and locations. Legacy flat roles remain for backend compatibility.',
    'settings.users.listTitle': 'Organization users',
    'settings.users.listSubtitle': 'Users and role assignments in the active organization',
    'settings.users.inviteTitle': 'Invite user',
    'settings.users.inviteHint': 'Send a link to a new team member — they set a password and receive a role in this organization.',
    'settings.users.inviteEmail': 'Email',
    'settings.users.inviteSubmit': 'Create invitation',
    'settings.users.inviteSuccess': 'Invitation created. Copy the link and share it with the user.',
    'settings.users.inviteLinkLabel': 'Invite acceptance link',
    'settings.users.inviteError': 'Failed to create invitation.',
    'settings.users.inviteRoleRequired': 'Select a role.',
    'settings.users.inviteEmailRequired': 'Enter an email address.',
    'settings.users.manageHint': 'Open a user card to change roles and assignments.',
    'settings.users.detailTitle': 'User: {name}',
    'settings.users.detail.profileTitle': 'User profile',
    'settings.users.detail.assignmentsTitle': 'Role assignments',
    'settings.users.detail.roleSummary': 'Current roles: {roles}',
    'settings.users.detail.notFound': 'User was not found in the active organization.',
    'settings.users.noOrganization': 'No active organization is available for user management.',
    'settings.users.backToList': 'Back to users',
    'settings.users.loading': 'Loading organization users…',
    'settings.users.loadError': 'Failed to load users and roles.',
    'settings.users.empty.title': 'No assignments',
    'settings.users.empty.description': 'No users with roles in this organization yet.',
    'settings.users.column.user': 'User',
    'settings.users.column.role': 'Role',
    'settings.users.column.roles': 'Roles',
    'settings.users.column.scope': 'Scope',
    'settings.users.column.assignments': 'Assignments',
    'settings.users.column.actions': 'Actions',
    'settings.users.assignmentsCount': '{count} assignments',
    'settings.users.action.open': 'Open',
    'settings.users.action.manage': 'Manage',
    'settings.users.scope.location': 'Location: {name}',
    'settings.users.scope.organization': 'Organization',
    'settings.users.viewOnly': 'View only',
    'settings.users.remove': 'Remove',
    'settings.users.userId': 'User ID',
    'settings.users.userIdPlaceholder': 'User UUID',
    'settings.users.role': 'Role',
    'settings.users.selectRole': 'Select role',
    'settings.users.rolesLoadError': 'Failed to load roles. Refresh the page.',
    'settings.users.noRolesAvailable': 'No roles are available for invitation. Check permissions or contact an administrator.',
    'settings.users.locationsLoadError': 'Failed to load locations. Refresh the page.',
    'settings.users.noOutletsInOrganization': 'This organization has no outlets — the role will apply to the whole organization.',
    'settings.users.locationOptional': 'Location (optional)',
    'settings.users.wholeOrganization': 'Whole organization',
    'settings.users.assignRole': 'Assign role',
    'settings.users.roleAssigned': 'Role assigned.',
    'settings.users.roleRemoved': 'Role assignment removed.',
    'settings.users.assignError': 'Failed to assign role.',
    'settings.users.removeError': 'Failed to remove assignment.',
    'settings.bankAdapters.title': 'Bank adapters',
    'settings.bankAdapters.subtitle': 'Technical catalog of supported statement formats (read-only)',
    'settings.bankAccounts.title': 'Bank accounts',
    'settings.bankAccounts.subtitle': 'Map a bank to a Syrve financial Account',
    'settings.bankAccounts.loading': 'Loading bank accounts…',
    'settings.bankAccounts.loadError': 'Failed to load bank accounts.',
    'settings.bankAccounts.saveError': 'Failed to save the bank account mapping.',
    'settings.bankAccounts.validationRequired': 'Select a Syrve Account.',
    'settings.bankAccounts.created': 'Bank account mapping created.',
    'settings.bankAccounts.saved': 'Bank account mapping saved.',
    'settings.bankAccounts.col.logo': 'Bank',
    'settings.bankAccounts.col.bank': 'Name',
    'settings.bankAccounts.col.account': 'Syrve Account',
    'settings.bankAccounts.pickAccount': 'Syrve Account',
    'settings.bankAccounts.save': 'Save',
    'settings.bankAccounts.viewOnly': 'Only accountants can change mappings.',
    'settings.docs.title': 'Documentation',
    'settings.docs.subtitle': 'MyHoreca Pay documentation portal',
    'settings.docs.linkPrefix': 'Full documentation is available at',
    'settings.outlets.pageTitle': 'Organization outlets',
    'settings.outlets.pageSubtitle': 'Sales outlets for operational context and Syrve RMS connections',
    'settings.outlets.pageSubtitleNamed': 'Outlets · {name}',
    'settings.outlets.listTitle': 'Outlet list',
    'settings.outlets.listSubtitle': 'Active outlets in the selected organization',
    'settings.outlets.createTitle': 'New outlet',
    'settings.outlets.createSubtitle': 'Syrve RMS requires at least one outlet in Pay',
    'settings.outlets.name': 'Name',
    'settings.outlets.namePlaceholder': 'e.g. Main restaurant',
    'settings.outlets.code': 'Code',
    'settings.outlets.codePlaceholder': 'main',
    'settings.outlets.codeHint': 'Short unique code within the organization (letters, digits, hyphen).',
    'settings.outlets.create': 'Create outlet',
    'settings.outlets.createAndContinue': 'Create outlet and select',
    'settings.outlets.created': 'Outlet created.',
    'settings.outlets.createError': 'Failed to create outlet.',
    'settings.outlets.validationRequired': 'Enter outlet name and code.',
    'settings.outlets.loading': 'Loading outlets…',
    'settings.outlets.loadError': 'Failed to load outlets.',
    'settings.outlets.empty': 'This organization has no outlets yet.',
    'settings.outlets.column.name': 'Name',
    'settings.outlets.column.code': 'Code',
    'settings.outlets.viewOnly': 'Only organization administrators can create outlets.',
    'settings.outlets.compactHint': 'RMS connections require an outlet. Create one here — fields can be prefilled from the connection name and server address.',
  },
  id: {
    'settings.title': 'Organization settings',
    'settings.subtitle': 'Limits and capabilities for the selected organization',
    'settings.subtitleNamed': 'Limits and capabilities · {name}',
    'settings.noOrganizationSelected': 'Select an organization in the header.',
    'settings.tabs.quota': 'Limits',
    'settings.tabs.users': 'Users',
    'settings.tabs.outlets': 'Outlets',
    'settings.tabs.telegram': 'Telegram',
    'settings.telegram.title': 'Tautan Telegram',
    'settings.telegram.subtitle': 'Kode pribadi sekali pakai (~10 menit). Bagikan tautan atau kode jika ponsel dan PC terpisah.',
    'settings.telegram.needOutlet': 'Pilih Outlet di header untuk menautkan Telegram.',
    'settings.telegram.disabled': 'Inbox Telegram dinonaktifkan di server (Telegram__Enabled).',
    'settings.telegram.linked': 'Telegram user #{id} tertaut',
    'settings.telegram.linkedAt': 'Ditautkan: {date}',
    'settings.telegram.generate': 'Buat kode',
    'settings.telegram.regenerate': 'Kode baru',
    'settings.telegram.unlink': 'Putuskan',
    'settings.telegram.code': 'Kode',
    'settings.telegram.deepLink': 'Tautan bot',
    'settings.telegram.expires': 'Berlaku hingga {date}',
    'settings.telegram.copyCode': 'Salin kode',
    'settings.telegram.openBot': 'Buka bot',
    'settings.telegram.loading': 'Memuat status Telegram…',
    'settings.telegram.loadError': 'Gagal memuat status Telegram.',
    'settings.telegram.generateError': 'Gagal membuat kode.',
    'settings.telegram.unlinkError': 'Gagal memutus Telegram.',
    'settings.telegram.unlinkConfirm': 'Putuskan akun Telegram ini dari pengguna Pay Anda?',
    'settings.organization': 'Organisasi',
    'settings.organizationLabel': 'Organisasi: {name}',
    'settings.quota.title': 'Kuota organisasi',
    'settings.quota.limitsTitle': 'Limits',
    'settings.quota.capabilitiesTitle': 'Capabilities',
    'settings.quota.loading': 'Loading organization limits…',
    'settings.quota.maxChains': 'Max chains',
    'settings.quota.maxLocations': 'Max outlets',
    'settings.quota.maxRmsConnections': 'Max Syrve connections',
    'settings.quota.maxUsers': 'Max users',
    'settings.quota.allowBankUpload': 'Unggah rekening koran',
    'settings.quota.allowBankUploadHint': 'Allow users in this organization to upload statements',
    'settings.quota.allowAutoSync': 'Syrve document sync',
    'settings.quota.allowAutoSyncHint': 'Automatically sync invoices and related Syrve documents',
    'settings.quota.save': 'Save',
    'settings.quota.noPermission': 'Only platform administrators can change organization limits.',
    'settings.quota.saved': 'Organization settings saved.',
    'settings.quota.loadError': 'Failed to load organization limits.',
    'settings.quota.saveError': 'Failed to save settings.',
    'settings.platform.pageTitle': 'Platform settings',
    'settings.platform.pageSubtitle': 'Global switches and matching parameters for the whole platform',
    'settings.platform.featuresTitle': 'Platform features',
    'settings.platform.matchingTitle': 'Payment matching',
    'settings.platform.bankUpload': 'Bank statement upload',
    'settings.platform.bankUploadHint': 'Globally allow or deny statement upload',
    'settings.platform.docSync': 'Syrve document sync',
    'settings.platform.docSyncHint': 'Globally enable or disable document sync',
    'settings.platform.matchingDateTolerance': 'Date tolerance (days)',
    'settings.platform.matchingDateToleranceHint': 'How many days payment dates may differ during auto-matching',
    'settings.platform.matchingAmountTolerance': 'Amount tolerance',
    'settings.platform.matchingAmountToleranceHint': 'Maximum amount deviation for exact matching',
    'settings.platform.save': 'Save',
    'settings.platform.saved': 'Platform settings saved.',
    'settings.platform.saveError': 'Failed to save platform settings.',
    'settings.platform.loadError': 'Failed to load platform settings.',
    'settings.platform.loading': 'Loading platform settings…',
    'settings.platform.noPermission': 'No access to platform settings.',
    'settings.platform.viewOnly': 'View only. Changes require platform administrator rights.',
    'settings.users.title': 'Pengguna dan peran',
    'settings.users.hint': 'Scoped RBAC: penugasan peran dalam organisasi dan lokasi. Legacy flat roles tetap untuk kompatibilitas backend.',
    'settings.users.listTitle': 'Pengguna organisasi',
    'settings.users.listSubtitle': 'Pengguna dan penugasan peran di organisasi aktif',
    'settings.users.inviteTitle': 'Undang pengguna',
    'settings.users.inviteHint': 'Kirim tautan ke anggota tim baru — mereka membuat kata sandi dan mendapat peran di organisasi ini.',
    'settings.users.inviteEmail': 'Email',
    'settings.users.inviteSubmit': 'Buat undangan',
    'settings.users.inviteSuccess': 'Undangan dibuat. Salin tautan dan bagikan kepada pengguna.',
    'settings.users.inviteLinkLabel': 'Tautan penerimaan undangan',
    'settings.users.inviteError': 'Gagal membuat undangan.',
    'settings.users.inviteRoleRequired': 'Pilih peran.',
    'settings.users.inviteEmailRequired': 'Masukkan email.',
    'settings.users.manageHint': 'Buka kartu pengguna untuk mengubah peran dan penugasan.',
    'settings.users.detailTitle': 'Pengguna: {name}',
    'settings.users.detail.profileTitle': 'Profil pengguna',
    'settings.users.detail.assignmentsTitle': 'Penugasan peran',
    'settings.users.detail.roleSummary': 'Peran saat ini: {roles}',
    'settings.users.detail.notFound': 'Pengguna tidak ditemukan di organisasi aktif.',
    'settings.users.noOrganization': 'Tidak ada organisasi aktif untuk manajemen pengguna.',
    'settings.users.backToList': 'Kembali ke pengguna',
    'settings.users.loading': 'Memuat pengguna organisasi…',
    'settings.users.loadError': 'Gagal memuat pengguna dan peran.',
    'settings.users.empty.title': 'Tidak ada penugasan',
    'settings.users.empty.description': 'Belum ada pengguna dengan peran di organisasi ini.',
    'settings.users.column.user': 'Pengguna',
    'settings.users.column.role': 'Peran',
    'settings.users.column.roles': 'Peran',
    'settings.users.column.scope': 'Scope',
    'settings.users.column.assignments': 'Penugasan',
    'settings.users.column.actions': 'Tindakan',
    'settings.users.assignmentsCount': '{count} penugasan',
    'settings.users.action.open': 'Buka',
    'settings.users.action.manage': 'Kelola',
    'settings.users.scope.location': 'Lokasi: {name}',
    'settings.users.scope.organization': 'Organisasi',
    'settings.users.viewOnly': 'Hanya lihat',
    'settings.users.remove': 'Hapus',
    'settings.users.userId': 'User ID',
    'settings.users.userIdPlaceholder': 'UUID pengguna',
    'settings.users.role': 'Peran',
    'settings.users.selectRole': 'Pilih peran',
    'settings.users.rolesLoadError': 'Gagal memuat daftar peran. Muat ulang halaman.',
    'settings.users.noRolesAvailable': 'Tidak ada peran yang tersedia untuk undangan. Periksa izin atau hubungi administrator.',
    'settings.users.locationsLoadError': 'Gagal memuat daftar lokasi. Muat ulang halaman.',
    'settings.users.noOutletsInOrganization': 'Organisasi ini tidak memiliki outlet — peran akan berlaku untuk seluruh organisasi.',
    'settings.users.locationOptional': 'Lokasi (opsional)',
    'settings.users.wholeOrganization': 'Seluruh organisasi',
    'settings.users.assignRole': 'Tetapkan peran',
    'settings.users.roleAssigned': 'Peran ditetapkan.',
    'settings.users.roleRemoved': 'Penugasan peran dihapus.',
    'settings.users.assignError': 'Gagal menetapkan peran.',
    'settings.users.removeError': 'Gagal menghapus penugasan.',
    'settings.bankAdapters.title': 'Adaptor bank',
    'settings.bankAdapters.subtitle': 'Katalog teknis format rekening koran yang didukung (hanya baca)',
    'settings.bankAccounts.title': 'Rekening bank',
    'settings.bankAccounts.subtitle': 'Petakan bank ke Account keuangan Syrve',
    'settings.bankAccounts.loading': 'Memuat rekening bank…',
    'settings.bankAccounts.loadError': 'Gagal memuat rekening bank.',
    'settings.bankAccounts.saveError': 'Gagal menyimpan pemetaan rekening bank.',
    'settings.bankAccounts.validationRequired': 'Pilih Account Syrve.',
    'settings.bankAccounts.created': 'Pemetaan rekening bank dibuat.',
    'settings.bankAccounts.saved': 'Pemetaan rekening bank disimpan.',
    'settings.bankAccounts.col.logo': 'Bank',
    'settings.bankAccounts.col.bank': 'Nama',
    'settings.bankAccounts.col.account': 'Account Syrve',
    'settings.bankAccounts.pickAccount': 'Account Syrve',
    'settings.bankAccounts.save': 'Simpan',
    'settings.bankAccounts.viewOnly': 'Hanya akuntan yang dapat mengubah pemetaan.',
    'settings.docs.title': 'Dokumentasi',
    'settings.docs.subtitle': 'Portal dokumentasi MyHoreca Pay',
    'settings.docs.linkPrefix': 'Dokumentasi lengkap tersedia di',
    'settings.outlets.pageTitle': 'Outlet organisasi',
    'settings.outlets.pageSubtitle': 'Titik penjualan untuk konteks operasional dan koneksi Syrve RMS',
    'settings.outlets.pageSubtitleNamed': 'Outlet · {name}',
    'settings.outlets.listTitle': 'Daftar outlet',
    'settings.outlets.listSubtitle': 'Outlet aktif di organisasi yang dipilih',
    'settings.outlets.createTitle': 'Outlet baru',
    'settings.outlets.createSubtitle': 'Syrve RMS memerlukan minimal satu outlet di Pay',
    'settings.outlets.name': 'Nama',
    'settings.outlets.namePlaceholder': 'mis. Restoran utama',
    'settings.outlets.code': 'Kode',
    'settings.outlets.codePlaceholder': 'main',
    'settings.outlets.codeHint': 'Kode unik singkat dalam organisasi (huruf, angka, tanda hubung).',
    'settings.outlets.create': 'Buat outlet',
    'settings.outlets.createAndContinue': 'Buat outlet dan pilih',
    'settings.outlets.created': 'Outlet dibuat.',
    'settings.outlets.createError': 'Gagal membuat outlet.',
    'settings.outlets.validationRequired': 'Isi nama dan kode outlet.',
    'settings.outlets.loading': 'Memuat outlet…',
    'settings.outlets.loadError': 'Gagal memuat daftar outlet.',
    'settings.outlets.empty': 'Organisasi ini belum memiliki outlet.',
    'settings.outlets.column.name': 'Nama',
    'settings.outlets.column.code': 'Kode',
    'settings.outlets.viewOnly': 'Hanya admin organisasi yang dapat membuat outlet.',
    'settings.outlets.compactHint': 'Koneksi RMS memerlukan outlet. Buat di sini — field dapat diisi dari nama koneksi dan alamat server.',
  },
} as const;
